import React, { useState, useEffect, useMemo } from "react";
import { Grid, Card, Avatar, Typography } from "@mui/material";
import { useNavigate,useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { useTranslation } from "react-i18next";
import { WEB_SECONDORY_COLOR, FONT_FAMILY, formatUserAmount, formatUserField, computeWalletTotals } from "../common/sharedFunctions";
import { api } from "common";
import Userinfo from "../components/Userinfo";
import { colors } from "components/Theme/WebTheme";
import GoBackButton from "components/GoBackButton";

function UserInfoDetails(props) {
    const {data} = props;
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir();
    const navigate = useNavigate();
    const { fetchUsersOnce, fetchUserWalletHistory } = api;
    const dispatch = useDispatch();
    const settings = useSelector((state) => state.settingsdata.settings);
    const staticusers = useSelector((state) => state.usersdata.staticusers);
    const [loading, setLoading] = useState(true);
    const [fleetAdminsObj, setFleetAdminsObj] = useState();
    const [role, setRole] = useState(null);
    const auth = useSelector(state => state.auth);
    const walletHistory = useSelector((state) => state.auth.walletHistory);
    const {state} = useLocation();
    const SECONDORY_COLOR = WEB_SECONDORY_COLOR(settings?.appCat);

    const isEqual = (obj1, obj2) => JSON.stringify(obj1) === JSON.stringify(obj2);

    useEffect(() => {
        if (auth.profile && auth.profile.usertype) {
          setRole(auth.profile.usertype);
        }
      }, [auth.profile]);

    useEffect(() => {
        if (staticusers) {
          if (role === 'admin' || role === 'fleetadmin') {
            let arr = staticusers.filter(user => user.usertype === 'fleetadmin');
            let obj = {};
    
            for (let i = 0; i < arr.length; i++) {
              let user = arr[i];
    
              obj[user.id] = user.firstName + ' ' + user.lastName;
            }
    
    
            if (!isEqual(obj, fleetAdminsObj)) {
              setFleetAdminsObj(obj);
            }
          }
        }
      }, [staticusers, role, fleetAdminsObj]);

    useEffect(()=>{
        if(data){
            setLoading(false)
        }
    },[data])
   

    useEffect(() => {
        dispatch(fetchUsersOnce());
    }, [dispatch, fetchUsersOnce]);

    useEffect(() => {
        if (data?.id) {
            dispatch(fetchUserWalletHistory(data.id));
        }
    }, [data?.id, dispatch, fetchUserWalletHistory]);

    const walletTotals = useMemo(
        () => computeWalletTotals(walletHistory),
        [walletHistory]
    );

    const allowSensitive = !!settings?.AllowCriticalEditsAdmin;
    const field = (value, sensitive = false) =>
        formatUserField(value, t, { sensitive, allowView: allowSensitive });

    const sectionTitle = (label) => (
        <Typography
            style={{
                fontFamily: FONT_FAMILY,
                fontSize: 17,
                fontWeight: 700,
                width: "100%",
                marginTop: 12,
                marginBottom: 4,
                textAlign: isRTL === "rtl" ? "right" : "left",
                color: colors.BLACK,
            }}
        >
            {label}
        </Typography>
    );


    return loading ? (
        <CircularLoading />
    ) : (
        <Card
            style={{
                borderRadius: "19px",
                backgroundColor: colors.WHITE,
                minHeight: 100,
                marginBottom: 20,
                padding: 20,
                boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
            }}
        >
            <GoBackButton 
                isRTL={isRTL} 
                onClick={() => {
                    data?.usertype ==="customer" ? 
                    navigate("/users/0",{state:{pageNo:state?.pageNo}})
                    :navigate("/users/1",{state:{pageNo:state?.pageNo}})
                }}
            />
            <Grid container spacing={1} sx={{ direction: isRTL === "rtl" ? "rtl" : "ltr", }}>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={4}
                    xl={4}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: 5,
                    }}
                >
                    {data.profile_image ? (
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <img
                                src={data.profile_image}
                                alt="Profile"
                                style={{
                                    width: 200,
                                    height: 250,
                                    borderRadius: "19px",
                                }}
                            />
                        </div>
                    ) : (
                        <Avatar sx={{ width: 200, height: 300, fontFamily:FONT_FAMILY }} variant="square">
                            {data?.firstName?.slice(0, 1) + " " + data?.lastName?.slice(0, 1)}
                        </Avatar>
                    )}
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={8} xl={8} gap={2}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: 5,
                    }}
                >
                    <Grid container spacing={2} sx={{ direction: isRTL === "rtl" ? "rtl" : "ltr", }}>
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                            <Userinfo title={"first_name"} value={data?.firstName} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                            <Userinfo title={"last_name"} value={data?.lastName} />
                        </Grid>
                    </Grid>
                    <Userinfo title={"mobile"} value={allowSensitive ? data?.mobile : t("hidden_demo")} />
                    <Userinfo title={"email"} value={allowSensitive ? data?.email : t("hidden_demo")} />

                    {sectionTitle(t("location_section_title", { defaultValue: "Ubicación (casa o empresa)" }))}
                    <Userinfo
                        title={"address_home_company"}
                        titleDefault={"Dirección (casa o empresa)"}
                        value={field(data?.address)}
                    />
                    <Userinfo
                        title={"department"}
                        titleDefault={"Departamento"}
                        value={field(data?.department)}
                    />
                    <Userinfo
                        title={"municipality"}
                        titleDefault={"Ciudad / Municipio"}
                        value={field(data?.municipality)}
                    />

                    {(data?.usertype === "driver" || data?.usertype === "customer") ? (
                        <>
                            {sectionTitle(t("bank_details_section", { defaultValue: "Datos bancarios" }))}
                            {data?.bankDetailsStatus === 'pending' && data?.pendingBankDetails ?
                                <Typography style={{ fontFamily: FONT_FAMILY, color: '#9A7B00', marginBottom: 8, width: '100%', textAlign: isRTL === "rtl" ? "right" : "left" }}>
                                    {t('bank_pending_review', { defaultValue: 'Cambio bancario pendiente de aprobación' })}
                                </Typography>
                                : null}
                            <Userinfo
                                title={"bankName"}
                                titleDefault={"Banco"}
                                value={field(data?.bankName, true)}
                            />
                            <Userinfo
                                title={"bankCode"}
                                titleDefault={"Código del banco"}
                                value={field(data?.bankCode, true)}
                            />
                            <Userinfo
                                title={"bankAccount"}
                                titleDefault={"Número de cuenta"}
                                value={field(data?.bankAccount, true)}
                            />
                            <Userinfo
                                title={"bankAccountType"}
                                titleDefault={"Tipo de cuenta"}
                                value={field(data?.bankAccountType, true)}
                            />
                        </>
                    ) : null}

                    {data?.usertype === "driver" ? (
                        <>
                            {sectionTitle(t("vehicle_section_title", { defaultValue: "Vehículo del socio" }))}
                            <Userinfo
                                title={"vehicle_make"}
                                titleDefault={"Marca"}
                                value={field(data?.vehicleMake)}
                            />
                            <Userinfo
                                title={"vehicle_model"}
                                titleDefault={"Modelo"}
                                value={field(data?.vehicleModel)}
                            />
                            <Userinfo
                                title={"vehicle_reg_no"}
                                titleDefault={"Placa"}
                                value={field(data?.vehicleNumber)}
                            />
                        </>
                    ) : null}

                    {sectionTitle(t("wallet_section_title", { defaultValue: "Billetera e impulso" }))}
                    <Grid container spacing={2} sx={{ width: "100%", mt: 0.5 }}>
                        <Grid item xs={12} sm={6}>
                            <Userinfo
                                title={"wallet_balance"}
                                value={formatUserAmount(data?.walletBalance, settings)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Userinfo
                                title={"wallet_total_recharged"}
                                titleDefault={"Total recargado en billetera"}
                                value={formatUserAmount(walletTotals.walletRecharged, settings)}
                            />
                        </Grid>
                        {data?.usertype === "driver" ? (
                            <>
                                <Grid item xs={12} sm={6}>
                                    <Userinfo
                                        title={"ad_balance_label"}
                                        value={formatUserAmount(data?.adBalance, settings)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Userinfo
                                        title={"ad_total_recharged"}
                                        titleDefault={"Total impulsado en perfil"}
                                        value={formatUserAmount(walletTotals.adRecharged, settings)}
                                    />
                                </Grid>
                            </>
                        ) : null}
                    </Grid>
                    <Grid container spacing={2} direction="row" justifyContent={"center"}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Userinfo title={"verify_id"} value={data?.verifyId ?
                                settings.AllowCriticalEditsAdmin ? data.verifyId : t("hidden_demo")
                                : t('no_data_available')
                            } />
                        </Grid>
                    </Grid>
                    {
                        (data?.usertype === "driver" || data?.usertype === "customer") && data?.fleetadmin ?  <Userinfo title={"fleetadmins"} value={(fleetAdminsObj && fleetAdminsObj[data?.fleetadmin] ? fleetAdminsObj[data?.fleetadmin] : "" )+ (data?.fleetadmin
                                ? settings.AllowCriticalEditsAdmin
                                  ? " ( " + data.fleetadmin + " ) "
                                  : " ( " + t("hidden_demo") + " ) "
                                : t('no_data_available'))
                            } />
                        :null
                    }
                </Grid>
            </Grid>
        </Card>
    );
}

export default UserInfoDetails;


